// Deprecated: save feedback now comes from the global snackbar
// (src/components/common/Snackbar.jsx, mounted in App.js). The empty
// container is kept so page layouts that flex around this element don't
// shift. Removing the remaining usages is tracked in docs/inbox.md.
const SavedNotice = () => {
  return (
    <div id='next-step-saved-container'></div>
  )
}

export default SavedNotice
